import Eyebrow from "@/components/Eyebrow";
import SEO from "@/components/SEO";
import FixturesSection from "@/components/FixturesSection";
import { Link } from "react-router-dom";

export default function ESAFC() {
  return (
    <>
      <SEO title="ESAFC Football Club" description="Emirates Sports Association FC — HOFA's Liberian third-division football club. 12-month player development, FKDP 101, community-first matches." path="/esafc" image="https://images.unsplash.com/photo-1517927033932-b3d18e61fb3a?auto=format&fit=crop&w=1600&q=80" />
      <section className="text-white pt-24 pb-20" style={{ background: "linear-gradient(150deg,#31517E,#1E3557)" }}>
        <div className="max-w-[1140px] mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          <div>
            <Eyebrow tone="mango">Emirates Sports Association FC</Eyebrow>
            <h1 className="font-display font-bold text-white text-[clamp(38px,5vw,60px)] mb-5">
              Football as a pathway.
            </h1>
            <p className="text-white/85 text-[18px] max-w-[54ch]">
              In 2026, HOFA acquired Emirates Sports Association FC — a Liberian third-division club — because a football pitch can be a classroom, a clinic, and a career path all at once.
            </p>
          </div>
          <div
            className="aspect-[4/3] rounded-[14px] relative overflow-hidden border-[3px] border-white/35"
            style={{ background: "linear-gradient(180deg,#2E7D4F,#1F5C38)" }}
            aria-hidden="true"
          >
            <div className="absolute left-0 right-0 top-1/2 h-0.5 bg-white/35" />
            <div className="absolute top-1/2 left-1/2 w-28 h-28 border-2 border-white/35 rounded-full -translate-x-1/2 -translate-y-1/2" />
            <b className="absolute bottom-5 left-0 right-0 text-center font-display text-2xl tracking-[0.06em]">ESAFC</b>
          </div>
        </div>
      </section>

      <section className="py-24">
        <div className="max-w-[1140px] mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-white border border-ink/10 rounded-[14px] p-8">
            <span className="text-xs uppercase tracking-[0.14em] font-bold text-palm">The Club</span>
            <h3 className="font-display text-2xl mt-2 mb-3">Third-division roots, first-class ambition.</h3>
            <p className="text-ink/80">ESAFC competes in Liberia's third division while building a youth pipeline modeled on top African academies. The club now sits inside HOFA's Economic Empowerment pillar — because opportunity and sport belong together.</p>
          </div>
          <div className="bg-white border border-ink/10 rounded-[14px] p-8">
            <span className="text-xs uppercase tracking-[0.14em] font-bold text-clay">FKDP 101</span>
            <h3 className="font-display text-2xl mt-2 mb-3">Football Knowledge Development Program.</h3>
            <p className="text-ink/80">Our 12-month development plan combines pre-season conditioning, tactical training, and classroom sessions on health, finance, and career readiness. Players graduate as athletes and citizens.</p>
          </div>
        </div>
      </section>

      <FixturesSection />

      <section className="bg-ink text-paper py-24">
        <div className="max-w-[1140px] mx-auto px-6">
          <Eyebrow tone="mango">Player development</Eyebrow>
          <h2 className="text-[clamp(30px,4vw,44px)] text-white mb-10">A whole-player approach.</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {[
              { title: "12-month plan", body: "Structured pre-season, in-season, and off-season blocks with individual growth targets." },
              { title: "Education first", body: "Every squad member stays enrolled in school or vocational training — no exceptions." },
              { title: "Community roots", body: "Home matches double as community days: health screenings, literacy booths, and family programming." },
            ].map((c) => (
              <div key={c.title} className="rounded-[14px] p-7 bg-white/5 border border-white/10">
                <h3 className="font-display text-xl mb-2 text-white">{c.title}</h3>
                <p className="text-white/75 text-[15px]">{c.body}</p>
              </div>
            ))}
          </div>
          <div className="mt-12 flex gap-4 flex-wrap">
            <Link to="/get-involved#donate" className="inline-block bg-mango text-palm-deep font-bold rounded-full px-7 py-3.5 no-underline hover:-translate-y-0.5 hover:shadow-xl transition" data-testid="esafc-sponsor-btn">
              Sponsor the club
            </Link>
            <Link to="/get-involved#partner" className="inline-block border-2 border-white/50 text-white font-bold rounded-full px-7 py-3.5 no-underline hover:border-white transition" data-testid="esafc-partner-btn">
              Partner with ESAFC
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
